// Feste Ausstattung aus dem abgenommenen Entwurf v12; von Hand gepflegt.
import type { RegalBlock } from '@/lib/handregal-geometrie'
export interface HandregalAusstattung {
  zusatzBloecke: RegalBlock[]
  ungenutzt: Array<{ von: number; bis: number; grund: string }>
  leer: Array<{ etage: 'EG' | 'OG'; band: number; spalteVon: number; spalteBis: number; ebene: number }>
  packtische: Array<{ band: number; spalte: number }>
  feldStart: { EG: number[]; OG: number[] }
  gang: { EG: number[]; OG: number[] }
  treppe: { EG: { spalteVon: number; spalteBis: number; text: string }; OG: { spalteVon: number; spalteBis: number; text: string } }
}
export const AUSSTATTUNG: HandregalAusstattung = {
  zusatzBloecke: [
  {
    "etage": "OG",
    "band": 6,
    "seite": "rechts",
    "block": 4,
    "von": 1942,
    "bis": 1956,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 13
  },
  {
    "etage": "OG",
    "band": 6,
    "seite": "rechts",
    "block": 5,
    "von": 1957,
    "bis": 1971,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 16
  },
  {
    "etage": "OG",
    "band": 6,
    "seite": "rechts",
    "block": 6,
    "von": 1972,
    "bis": 1986,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 19
  },
  {
    "etage": "OG",
    "band": 5,
    "seite": "rechts",
    "block": 4,
    "von": 1987,
    "bis": 2001,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 19
  },
  {
    "etage": "OG",
    "band": 5,
    "seite": "rechts",
    "block": 5,
    "von": 2002,
    "bis": 2016,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 16
  },
  {
    "etage": "OG",
    "band": 5,
    "seite": "rechts",
    "block": 6,
    "von": 2017,
    "bis": 2031,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 13
  },
  {
    "etage": "OG",
    "band": 4,
    "seite": "rechts",
    "block": 3,
    "von": 2032,
    "bis": 2046,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 13
  },
  {
    "etage": "OG",
    "band": 4,
    "seite": "rechts",
    "block": 4,
    "von": 2047,
    "bis": 2061,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 19
  },
  {
    "etage": "OG",
    "band": 3,
    "seite": "rechts",
    "block": 4,
    "von": 2062,
    "bis": 2076,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 19
  },
  {
    "etage": "OG",
    "band": 3,
    "seite": "rechts",
    "block": 5,
    "von": 2077,
    "bis": 2091,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 16
  },
  {
    "etage": "OG",
    "band": 3,
    "seite": "rechts",
    "block": 6,
    "von": 2092,
    "bis": 2106,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 13
  },
  {
    "etage": "OG",
    "band": 2,
    "seite": "rechts",
    "block": 4,
    "von": 2107,
    "bis": 2121,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 13
  },
  {
    "etage": "OG",
    "band": 2,
    "seite": "rechts",
    "block": 5,
    "von": 2122,
    "bis": 2136,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 16
  },
  {
    "etage": "OG",
    "band": 2,
    "seite": "rechts",
    "block": 6,
    "von": 2137,
    "bis": 2151,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": true,
    "bodenOben": true,
    "zeile": 0,
    "spalte": 19
  },
  {
    "etage": "OG",
    "band": 1,
    "seite": "rechts",
    "block": 4,
    "von": 2152,
    "bis": 2166,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 19
  },
  {
    "etage": "OG",
    "band": 1,
    "seite": "rechts",
    "block": 5,
    "von": 2167,
    "bis": 2181,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 16
  },
  {
    "etage": "OG",
    "band": 1,
    "seite": "rechts",
    "block": 6,
    "von": 2182,
    "bis": 2196,
    "breite": 3,
    "hoehe": 5,
    "aufsteigend": false,
    "bodenOben": false,
    "zeile": 0,
    "spalte": 13
  }
],
  ungenutzt: [{ von: 1942, bis: 2196, grund: 'OG Gang 1–3 rechts: Regal steht, wird nicht genutzt' }],
  leer: [{ etage: 'OG', band: 1, spalteVon: 2, spalteBis: 10, ebene: 5 }],
  packtische: [{ band: 4, spalte: 5 }, { band: 4, spalte: 16 }, { band: 7, spalte: 5 }, { band: 7, spalte: 16 }],
  feldStart: { EG: [5, 9, 13, 21, 25], OG: [5, 8, 16, 19] },
  gang: { EG: [16], OG: [11, 12] },
  treppe: {
    EG: { spalteVon: 2, spalteBis: 11, text: 'Treppe ↗ nach oben · Antritt bei 738' },
    OG: { spalteVon: 2, spalteBis: 10, text: 'Treppe ↗ kommt hier am Gang oben an' },
  },
}
